import React from 'react';
import { UsagePricingDataContainer } from './BundleCards.styled';
import { UsagePricingTableFont } from 'src/common/components/orderDetails/detailsDataTable/DetailsDataTable.styled';
import { capitalizeText } from 'src/utils/util';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
  
const ItemDescriptionLabel = ({
    width,
    description,
    brand,
    lineHeight,
    letterSpacing,
    orient,
    textOverflow,
    overflow,
    lineClamp,
    color,
    fontSize,
    display,
    marginContainer,
    mobileFontSize,
    flexDirection,
    descHeight,
}) => {
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const { t } = useTranslation();
    return (
        <>
            <UsagePricingDataContainer
                style={{ display: 'block' }}
                margin={marginContainer ? marginContainer : '0 0 10px 0'}
                width={width}
                flexDirection={flexDirection}
            >
                <UsagePricingTableFont
                    lineHeight={lineHeight}
                    letterSpacing={letterSpacing}
                    orient={orient}
                    textOverflow={textOverflow}
                    overflow={overflow}
                    lineClamp={lineClamp}
                    color={color}
                    fontSize={fontSize}
                    display={display}
                    mobileFontSize={mobileFontSize}
                    descHeight={descHeight}
                >
                    {description ? capitalizeText(description) : null}
                </UsagePricingTableFont>
                {brand && orderBasicDetails?.currentOrderType == 'ZOR' && (
                    <div style={{ fontFamily: 'AvenirNextWorld Regular' }}>
                        <span style={{ color: '#202124', fontWeight: 'bold' }}>
                            {t('ConsignmentAdd.common.bundleItems.brand')}{' '}
                        </span>
                        {brand}
                    </div>
                )}
            </UsagePricingDataContainer>
        </>
    );
};

export default ItemDescriptionLabel;
